module.exports = __webpack_public_path__ + "static/media/71F6eID-ImL._SL1500_.4a8930ad.jpg";